import { SVC_B } from '@/libraries/api/base'
import querystring from 'querystring'

export function getZip4 (address) {
  return SVC_B.get(`/api/v1/usps/zip4?`, querystring.stringify(address))
}
